import { mergeStyles } from '@fluentui/react';
import React from 'react';
import Header from './Header/Header';
import './PageBase.scss';

type TPageBaseProps = {
    maxContentWidth?: string;
    imgSrc?: string;
    imgSrcAlt?: string;
    imgComponent?: JSX.Element;
    imgClassName?: string;
    hideBackButton?: boolean;
    imgStyles?: React.CSSProperties;
    contentClassName?: string;
    imgWrapperClassName?: string;
    pageBaseBodyClassName?: string;
    pageBaseClassName?: string;
};

const PageBase: React.FC<React.PropsWithChildren<TPageBaseProps>> = ({ children, maxContentWidth, imgSrc, imgComponent, imgWrapperClassName, imgClassName, imgStyles, hideBackButton, imgSrcAlt, pageBaseBodyClassName, pageBaseClassName, contentClassName }) => {
    const hasImage = imgSrc || imgComponent || imgSrcAlt;

    return (
        <div className={mergeStyles("page-base", pageBaseClassName)}>
            <Header hideBackButton={hideBackButton}/>
            <div className={mergeStyles("page-base__body", pageBaseBodyClassName)}>
                {(imgSrc || imgComponent) &&
                    <div className={mergeStyles("page-base__image-wrap", imgWrapperClassName)}>
                        {imgComponent ?? <img src={imgSrc} key={imgSrc} className={mergeStyles("page-base__image page-base__fadein", imgClassName)} alt="main" style={imgStyles} />}
                    </div>
                }
                <div className={mergeStyles(hasImage ? `page-base__content-with-images  ${contentClassName}` : "page-base__content-only")} style={maxContentWidth ? { maxWidth: maxContentWidth } : undefined}>
                    {children}
                </div>
                {imgSrcAlt &&
                    <div className="page-base__image-alt-wrap">
                        <img src={imgSrcAlt} key={imgSrcAlt} className="page-base__image page-base__fadein" alt="main" />
                    </div>
                }
            </div>
            <div className="page-base__footer" />
        </div>
    );
};

export default PageBase;
